import { Drill, DrillId } from '../drill';
import { BrakeDrill } from './brake';
import { Figure8Drill } from './figure8';
import { ThrottleDrill } from './throttle';

export const DRILL_IDS: readonly DrillId[] = ['throttle', 'brake', 'figure8'];

/** Fresh drill instances; a drill is single-use, make a new one per attempt. */
export const createDrill = (id: DrillId): Drill =>
  id === 'throttle' ? new ThrottleDrill() : id === 'brake' ? new BrakeDrill() : new Figure8Drill();

export { BrakeDrill, Figure8Drill, ThrottleDrill };
